import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_phyk4zwbt3: FaireBrandEntity = {
  token: "b_phyk4zwbt3",
  type: "brand",
  name: "Mienne",
  avatarUrl:
    "https://cdn.faire.com/fastly/3ddd51a51636e33b0b89e626afcbd150b63c87f12a914285edeffb3b79018b20.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0a7568d875f7076a458b78f033d8d7f5046d9efc154c41847adc4a653474567e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3ddd51a51636e33b0b89e626afcbd150b63c87f12a914285edeffb3b79018b20.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0a7568d875f7076a458b78f033d8d7f5046d9efc154c41847adc4a653474567e.jpeg",
  location: "HOUSTON, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "HOUSE OF MIENNE\nA world where body care is felt, not just seen.\n\nOur products are designed to be desired—functional, sculptural, and inviting by nature. We consider every detail: finish, texture, ingredient, and form transforming routine into ritual, and ritual into closeness.",
  meta: {
    source: "api",
    importedAt: "2026-06-24T20:37:20.755Z",
    importedBy: "entity-db-cli",
  },
};
